// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-section {
  display: grid;
  gap: 0.25rem;
}

/* Schritte */
.buy-steps .step-body > p {
  color: var(--text-secondary);
}

.step-title {
  font-weight: 700;
  color: var(--text-primary);
}

.wfid-field {
  display: grid;
  gap: 0.35rem;
  max-width: 22rem;
}

.wfid-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.wfid-input {
  width: 100%;
  font-family: var(--font-mono);
  font-size: 1.15rem;
  letter-spacing: 0.12em;
  background: var(--bg-primary);
}

.wfid-input-wrap.valid .wfid-input {
  border-color: var(--success);
}

.wfid-input-wrap.letters .wfid-input,
.wfid-input-wrap.length .wfid-input {
  border-color: var(--warning);
}

.wfid-ok {
  position: absolute;
  right: 0.8rem;
  color: var(--success);
}

.wfid-help {
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-tertiary);
}

.wfid-help.warn {
  color: var(--warning);
}

.buy-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 1.5rem;
  margin: 0.5rem 0 0.25rem;
}

.price {
  display: grid;
}

.price-amount {
  font-family: var(--font-display);
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.price-tax {
  font-family: var(--font-mono);
  font-size: 0.74rem;
  color: var(--text-tertiary);
}

.buy-btn {
  min-width: 10rem;
}

.buy-notes {
  margin: 0.75rem 0 0;
  padding-left: 1.1rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.buy-notes li + li {
  margin-top: 0.25rem;
}

.payment-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.9rem;
}

.payment-methods img {
  height: 26px;
  width: auto;
  padding: 3px 6px;
  background: #fff;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-sm);
}

.elite-flow {
  display: grid;
  gap: 0.5rem;
  justify-items: start;
}

.elite-flow > p {
  margin: 0;
  color: var(--text-primary);
}

.elite-flow .buy-notes {
  margin-bottom: 0.75rem;
}

.buy-guide-link {
  margin: 1.25rem 0 0;
}

.form-error {
  margin: 0.5rem 0 0;
  padding: 0.6rem 0.8rem;
  border: 1px solid var(--error);
  color: var(--error);
  font-size: 0.92rem;
}

/* WatchfaceID-Eingabe als eigene Karte */
.wfid-card {
  --frame-color: var(--neon-buy);
  border-color: color-mix(in srgb, var(--neon-buy) 45%, var(--border-primary));
  display: grid;
  gap: 0.6rem;
  max-width: 34rem;
  padding: 1.1rem 1.2rem 1rem;
  --note-ground: var(--bg-secondary);
}

.wfid-label {
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-primary);
}

.wfid-card .wfid-input {
  min-height: 52px;
  font-size: 1.35rem;
  background: var(--bg-primary);
}

.wfid-card .note {
  margin: 0.4rem 0 0;
}

.wfid-where {
  border-top: 1px solid var(--border-primary);
  padding-top: 0.5rem;
}

.wfid-where summary {
  cursor: pointer;
  font-weight: 700;
  color: var(--accent-primary);
}

.wfid-where .steps {
  margin: 0.75rem 0 0.25rem;
}

/* Bezahlen: Karte mit Preis und Knopf */
.checkout-card {
  border: 2px solid var(--neon-buy);
  display: grid;
  gap: 0.5rem;
  max-width: 34rem;
  padding: 1.1rem 1.2rem 1rem;
  --frame-color: var(--neon-buy);
}

.checkout-card .buy-row {
  justify-content: space-between;
  margin: 0;
}

.checkout-text {
  margin: 0;
  font-size: 0.92rem;
  color: var(--text-secondary);
}

.checkout-card .payment-methods {
  margin-top: 0.4rem;
}

.buy-steps > li {
  padding-bottom: 1.6rem;
}

.band-buy .segmented,
.band-buy .version-compare {
  background: var(--bg-secondary);
}

.band-buy .version-compare {
  padding: 1rem 1.2rem;
  border: 1px solid var(--band-buy-border);
}

/* VX / Elite: deutlich als Auswahl erkennbar (Radio-Punkt, Neon-Rahmen beim gewählten) */
.version-choose-label {
  margin: 1.25rem 0 0.5rem;
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-primary);
}

.segmented.version-switch {
  gap: 0.6rem;
  margin-top: 0;
  border: 0;
  overflow: visible;
  background: transparent;
}

.segmented.version-switch button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.65rem;
  min-height: 56px;
  padding: 0.7rem 0.9rem;
  border: 2px solid var(--border-secondary);
  border-radius: var(--radius-sm);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.82rem;
  text-align: left;
}

.segmented.version-switch button + button {
  border-left: 2px solid var(--border-secondary);
}

.segmented.version-switch button::before {
  content: '';
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid var(--text-tertiary);
  border-radius: 50%;
  box-sizing: border-box;
}

.segmented.version-switch button.active {
  border-color: var(--neon-buy);
  background: color-mix(in srgb, var(--neon-buy) 14%, var(--bg-secondary));
  color: var(--text-primary);
  box-shadow: 0 0 0 3px var(--neon-buy-glow);
}

.segmented.version-switch button.active::before {
  border-color: var(--neon-buy);
  background: radial-gradient(circle, var(--neon-buy) 0 45%, transparent 50%);
}

.segmented.version-switch button:not(.active):hover {
  border-color: var(--neon-buy);
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/PaymentSection/PaymentSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,aAAa;AACb;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,8BAA8B;EAC9B,4EAA4E;EAC5E,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,iCAAiC;EACjC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA,yFAAyF;AACzF;EACE,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,wEAAwE;EACxE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,2EAA2E;AAC7E;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B","sourcesContent":[".payment-section {\n  display: grid;\n  gap: 0.25rem;\n}\n\n/* Schritte */\n.buy-steps .step-body > p {\n  color: var(--text-secondary);\n}\n\n.step-title {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.wfid-field {\n  display: grid;\n  gap: 0.35rem;\n  max-width: 22rem;\n}\n\n.wfid-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.wfid-input {\n  width: 100%;\n  font-family: var(--font-mono);\n  font-size: 1.15rem;\n  letter-spacing: 0.12em;\n  background: var(--bg-primary);\n}\n\n.wfid-input-wrap.valid .wfid-input {\n  border-color: var(--success);\n}\n\n.wfid-input-wrap.letters .wfid-input,\n.wfid-input-wrap.length .wfid-input {\n  border-color: var(--warning);\n}\n\n.wfid-ok {\n  position: absolute;\n  right: 0.8rem;\n  color: var(--success);\n}\n\n.wfid-help {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--text-tertiary);\n}\n\n.wfid-help.warn {\n  color: var(--warning);\n}\n\n.buy-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem 1.5rem;\n  margin: 0.5rem 0 0.25rem;\n}\n\n.price {\n  display: grid;\n}\n\n.price-amount {\n  font-family: var(--font-display);\n  font-size: 2.2rem;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.price-tax {\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  color: var(--text-tertiary);\n}\n\n.buy-btn {\n  min-width: 10rem;\n}\n\n.buy-notes {\n  margin: 0.75rem 0 0;\n  padding-left: 1.1rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.buy-notes li + li {\n  margin-top: 0.25rem;\n}\n\n.payment-methods {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.9rem;\n}\n\n.payment-methods img {\n  height: 26px;\n  width: auto;\n  padding: 3px 6px;\n  background: #fff;\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-sm);\n}\n\n.elite-flow {\n  display: grid;\n  gap: 0.5rem;\n  justify-items: start;\n}\n\n.elite-flow > p {\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.elite-flow .buy-notes {\n  margin-bottom: 0.75rem;\n}\n\n.buy-guide-link {\n  margin: 1.25rem 0 0;\n}\n\n.form-error {\n  margin: 0.5rem 0 0;\n  padding: 0.6rem 0.8rem;\n  border: 1px solid var(--error);\n  color: var(--error);\n  font-size: 0.92rem;\n}\n\n/* WatchfaceID-Eingabe als eigene Karte */\n.wfid-card {\n  --frame-color: var(--neon-buy);\n  border-color: color-mix(in srgb, var(--neon-buy) 45%, var(--border-primary));\n  display: grid;\n  gap: 0.6rem;\n  max-width: 34rem;\n  padding: 1.1rem 1.2rem 1rem;\n  --note-ground: var(--bg-secondary);\n}\n\n.wfid-label {\n  font-family: var(--font-display);\n  font-size: 1.15rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-primary);\n}\n\n.wfid-card .wfid-input {\n  min-height: 52px;\n  font-size: 1.35rem;\n  background: var(--bg-primary);\n}\n\n.wfid-card .note {\n  margin: 0.4rem 0 0;\n}\n\n.wfid-where {\n  border-top: 1px solid var(--border-primary);\n  padding-top: 0.5rem;\n}\n\n.wfid-where summary {\n  cursor: pointer;\n  font-weight: 700;\n  color: var(--accent-primary);\n}\n\n.wfid-where .steps {\n  margin: 0.75rem 0 0.25rem;\n}\n\n/* Bezahlen: Karte mit Preis und Knopf */\n.checkout-card {\n  border: 2px solid var(--neon-buy);\n  display: grid;\n  gap: 0.5rem;\n  max-width: 34rem;\n  padding: 1.1rem 1.2rem 1rem;\n  --frame-color: var(--neon-buy);\n}\n\n.checkout-card .buy-row {\n  justify-content: space-between;\n  margin: 0;\n}\n\n.checkout-text {\n  margin: 0;\n  font-size: 0.92rem;\n  color: var(--text-secondary);\n}\n\n.checkout-card .payment-methods {\n  margin-top: 0.4rem;\n}\n\n.buy-steps > li {\n  padding-bottom: 1.6rem;\n}\n\n.band-buy .segmented,\n.band-buy .version-compare {\n  background: var(--bg-secondary);\n}\n\n.band-buy .version-compare {\n  padding: 1rem 1.2rem;\n  border: 1px solid var(--band-buy-border);\n}\n\n/* VX / Elite: deutlich als Auswahl erkennbar (Radio-Punkt, Neon-Rahmen beim gewählten) */\n.version-choose-label {\n  margin: 1.25rem 0 0.5rem;\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--text-primary);\n}\n\n.segmented.version-switch {\n  gap: 0.6rem;\n  margin-top: 0;\n  border: 0;\n  overflow: visible;\n  background: transparent;\n}\n\n.segmented.version-switch button {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.65rem;\n  min-height: 56px;\n  padding: 0.7rem 0.9rem;\n  border: 2px solid var(--border-secondary);\n  border-radius: var(--radius-sm);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  text-align: left;\n}\n\n.segmented.version-switch button + button {\n  border-left: 2px solid var(--border-secondary);\n}\n\n.segmented.version-switch button::before {\n  content: '';\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--text-tertiary);\n  border-radius: 50%;\n  box-sizing: border-box;\n}\n\n.segmented.version-switch button.active {\n  border-color: var(--neon-buy);\n  background: color-mix(in srgb, var(--neon-buy) 14%, var(--bg-secondary));\n  color: var(--text-primary);\n  box-shadow: 0 0 0 3px var(--neon-buy-glow);\n}\n\n.segmented.version-switch button.active::before {\n  border-color: var(--neon-buy);\n  background: radial-gradient(circle, var(--neon-buy) 0 45%, transparent 50%);\n}\n\n.segmented.version-switch button:not(.active):hover {\n  border-color: var(--neon-buy);\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
